import { Api } from 'eosjs'
// @ts-ignore - local non-typed lib
import ScatterJS from '@/lib/scatterjs/core'
// @ts-ignore - local non-typed lib
import ScatterEOS from '@/lib/scatterjs/eosjs'
import type { EosAccount, EosAction, EosConfig, TransactionResult, WalletAdapter } from '@/types'

export class ScatterWallet implements WalletAdapter {
  private provider: any = ScatterJS
  private eos: any = null
  private accounts: EosAccount[] = []

  async connect(config: EosConfig, rpc: unknown): Promise<EosAccount[]> {
    const url = new URL(config.rpcUrl)
    const network = this.provider.Network.fromJson({
      blockchain: 'eos',
      chainId: config.chainId,
      host: url.host,
      port: url.port ? Number(url.port) : url.protocol === 'https:' ? 443 : 80,
      protocol: url.protocol.replace(':', ''),
    })
    this.provider.plugins(new ScatterEOS())
    const connected = await this.provider.connect('Totoro', { network })
    if (!connected) throw new Error('no scatter')
    this.eos = this.provider.eos(network, Api, { rpc })
    this.accounts = this.provider.scatter?.identity?.accounts || []
    return this.accounts
  }

  async login(): Promise<EosAccount[]> {
    const identity = await this.provider.login()
    if (!identity) return []
    this.accounts = identity.accounts
    return this.accounts
  }

  async logout(): Promise<void> {
    this.accounts = []
    await this.provider.logout()
  }

  async transact(actions: EosAction[]): Promise<TransactionResult> {
    const options = { blocksBehind: 3, expireSeconds: 120 }
    return this.eos.transact({ actions }, options)
  }
}
